module.exports = __webpack_public_path__ + "banquet/containers/MarketingPricingContainer/images/coming_back.525e0bd246f0a8c811df616c874de0f0.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/containers/MarketingPricingContainer/images/coming_back.svg
// module id = 1715
// module chunks = 1